// @ts-nocheck
import React from "react";
import PropTypes from "prop-types";

import RichText from "./richText";

export default function EmbedColumns({ styles, column1, column2, column3 }) {
    return (
        <div className={styles.embedColumns}>
            {column1 && (
                <div className={styles.embedColumnsColumn}>
                    <RichText content={column1} />
                </div>
            )}
            {column2 && (
                <div className={styles.embedColumnsColumn}>
                    <RichText content={column2} />
                </div>
            )}
            {column3 && (
                <div className={styles.embedColumnsColumn}>
                    <RichText content={column3} />
                </div>
            )}
        </div>
    );
}

EmbedColumns.propTypes = {
    column1: PropTypes.object,
    column2: PropTypes.object,
    column3: PropTypes.object,
    styles: PropTypes.object,
};
